import Countries from "./countries.json";

export const allCountriesCode = Countries.map(country => ({
  value: country.dial_code,
  label: country.name,
}));
